module.exports = __webpack_public_path__ + "img/banner-middle-1.590ab2ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-middle/banner-middle-1.jpg
// module id = qZX4
// module chunks = 1